module.exports = __webpack_public_path__ + "img/Document.d438092d.svg";